import React, { Component } from 'react';
import { request } from '../../util/APIUtils';
import './NobetciEczaneParam.css';
import { ACCESS_TOKEN, API_BASE_URL } from '../../constants';
import Alert from "react-s-alert";

class NobetParams extends Component {
  constructor(props) {
    super(props);
    this.state = {
       avmNobetciEczane: 'Evet',
         nobetYuzdesi: 100,
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSaveClick = () => {

    if (!this.props.location.search) {
      this.createDefaultDutyParameters();
    } else {

      this.createDutyParameters();
    }
  };

  createDefaultDutyParameters = () => {
    const token = localStorage.getItem(ACCESS_TOKEN);
    const apiUrl = API_BASE_URL + '/dutyparameters/createDuty';
    let message;

    const defaultDutyParameters = {
      avmDahil: this.state.avmNobetciEczane === 'Evet',
      nobetciSayisi: this.state.nobetYuzdesi,
    };

    request({
      url: apiUrl,
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
      data: defaultDutyParameters,
    })
      .then(response => {
        console.log('Nöbetçi Eczaneler:', response);
        message = ('Nöbetçi eczaneler başarıyla oluşturuldu.');
        Alert.success(
            message, {
              position: 'top-right',
              effect: 'stackslide',
              timeout: 5000
            });

        this.props.history.push("/nobetcieczane");
      })
      .catch(error => {
        console.error('Nöbet oluşturulurken bir hata oluştu!', error);
      });
  };


  render() {
    return (
      <div className="nobetci-eczane-param">
        <h4> Nöbet Parametreleri </h4>
        <div className="inner-page-content">

          <div className="nobetci-eczane-madde">
            <label>
              AVM Eczaneleri Nöbete Dahil Edilsin Mi?
            </label>
            <div className="radio-group">
              <label style={{gap:"5px"}}>
                <input
                  type="radio"
                  name="avmNobetciEczane"
                  value="Evet"
                  checked={this.state.avmNobetciEczane === "Evet"}
                  onChange={this.handleInputChange}
                />
                 Evet
              </label>
              <label style={{gap:"5px"}}>
              <input
                  type="radio"
                  name="avmNobetciEczane"
                  value="Hayır"
                  checked={this.state.avmNobetciEczane === "Hayır"}
                  onChange={this.handleInputChange}
                />
                 Hayır
              </label>
            </div>
          </div>

          <div className="nobetci-eczane-madde">
            <label>
              Tüm Üye Eczanelerin % Kaçı Nöbete Dahil Edilsin: {}
              <input
                className="eczaneinput"
                type="text"
                name="nobetYuzdesi"
                value={this.state.nobetYuzdesi}
                onChange={this.handleInputChange}
              />
            </label>
          </div>
          <button className="nobetci-eczane-button" onClick={this.handleSaveClick}>Kaydet</button>
        </div>
      </div>
    );
  }
}

export default NobetParams;



// WEBPACK FOOTER //
// ./src/page/nobetParams/NobetParams.js